import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Button, Radio, Divider, Alert, Spin, message } from "antd";

import Axios from "axios";
import { useDispatch } from "react-redux";
import { getResourcesAsync } from "../../../redux/resourceSlice";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

// import { testConnectionConnection } from '../../api/connectRestAPI'
const { REACT_APP_CONNECTION_INFO_BASE_URL } = process.env;
const MongoDBForm = (props) => {
  const [form] = Form.useForm();
  const [apiName, setApiName] = useState("");
  const [apiNameError, setApiNameError] = useState(false);
  const [hostError, setHostError] = useState(false);
  const [portError, setPortError] = useState(false);
  const [apiHost, setApiHost] = useState("");
  const [apiTestStatus, setApiTestStatus] = useState("");
  const [apiSaveStatus, setApiSaveStatus] = useState("");
  const [connectionType, setConnectionType] = useState("standard");
  const [portId, setPortId] = useState("");
  const [databaseName, setDatabaseName] = useState("");
  const [databaseUsername, setDatabaseUsername] = useState("");
  const [databasePassword, setDatabasePassword] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [resourceNameValidation, setResourceNameValidation] = useState({
    status: "",
    message: "",
  });
  const [debounceTimer, setDebounceTimer] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(null);

  const dispatch = useDispatch();

  const resourceNameRef = useRef(null);

  useEffect(() => {
    if (props.selectedResource && props.selectedResource.connectionData) {
      const resource = props.selectedResource;
      const connectionData = resource.connectionData;

      // Set all state values
      setApiName(resource.name || "");
      setApiHost(connectionData.host || "");
      setPortId(connectionData.port || "");
      setConnectionType(connectionData.connectionType || "standard");
      setDatabaseName(connectionData.databaseName || "");
      setDatabaseUsername(connectionData.databaseUsername || "");
      setDatabasePassword(connectionData.databasePassword || "");

      // Set form field values using setFieldsValue
      form.setFieldsValue({
        apinameName: resource.name || "",
        host: connectionData.host || "",
        port: connectionData.port || "",
        connectionType: connectionData.connectionType || "standard",
        databaseName: connectionData.databaseName || "",
        databaseUsername: connectionData.databaseUsername || "",
        databasePassword: connectionData.databasePassword || "",
      });
    }
  }, [props.selectedResource, form]);

  useEffect(() => {
    if (resourceNameRef.current && cursorPosition !== null) {
      resourceNameRef.current.input.setSelectionRange(cursorPosition, cursorPosition);
      resourceNameRef.current.focus();
    }
  }, [resourceNameValidation]);

  const testConnection = async () => {
    setApiTestStatus("pending");
    setApiSaveStatus("");
  };

  const checkGroupNameDuplicate = async (name) => {
    if (!name || name.trim() === "") {
      setResourceNameValidation({ status: "", message: "" });
      return;
    }

    // Store cursor position BEFORE setting checking status
    if (resourceNameRef.current && resourceNameRef.current.input) {
      setCursorPosition(resourceNameRef.current.input.selectionStart);
    }

    setResourceNameValidation({ status: "checking", message: "Checking availability..." });
    try {
      const response = await fetch(`${REACT_APP_CONNECTION_INFO_BASE_URL}/check-resource-duplicate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({
          name: name.trim(),
          id: props.resourceType?.id || null,
        }),
      });

      const data = await response.json();

      // Update cursor position again before setting result
      if (resourceNameRef.current && resourceNameRef.current.input) {
        setCursorPosition(resourceNameRef.current.input.selectionStart);
      }

      if (data.isDuplicate) {
        setResourceNameValidation({
          status: "duplicate",
          message: data.message || "A Resource with this name already exists",
        });
      } else {
        setResourceNameValidation({
          status: "available",
          message: "Resource name is available",
        });
      }
    } catch (error) {
      setResourceNameValidation({
        status: "error",
        message: "Error checking resource name availability",
      });
    }
  };
  const handleSaveConnection = async () => {
    setFormSubmitted(true);

    const values = await form.validateFields();

    if (resourceNameValidation.status === "duplicate") {
      message.destroy();
      message.error("Please resolve resource name duplicate issue before saving");

      return;
    }

    const BASE_URL = REACT_APP_CONNECTION_INFO_BASE_URL;
    const JWT_TOKEN = `Bearer ${localStorage.getItem("accessToken")}`;
    setApiTestStatus("");
    setApiSaveStatus("pending");

    let postData = {
      name: values.apinameName,
      icon: props.resourceType.icon,
      category: props.resourceType.category,
      description: props.resourceType.description,
      isActive: true,
      resoueceType: "MongoDB",
      connectionData: {
        host: values.host,
        port: values.port || "",
        databaseName: values.databaseName || "",
        databaseUsername: values.databaseUsername || "",
        databasePassword: values.databasePassword || "",
        connectionType: values.connectionType,
        requestValues: {},
      },
    };

    try {
      if (props.selectedResource && props.selectedResource.id) {
        // UPDATE existing resource
        postData.id = props.selectedResource.id;
        const UPDATE_URL = `${BASE_URL}/update-resource`;

        await Axios.post(UPDATE_URL, postData, {
          headers: { Authorization: JWT_TOKEN },
        });
      } else {
        // CREATE new resource
        const CREATE_URL = `${BASE_URL}/resource`;

        await Axios.post(CREATE_URL, postData, {
          headers: { Authorization: JWT_TOKEN },
        });
      }

      setApiSaveStatus("success");

      if (props.clearSearch) {
        props.clearSearch();
      }
      setTimeout(() => {
        props.handleClose();
        dispatch(getResourcesAsync());
      }, 1500);
    } catch (error) {
      setApiSaveStatus("error");
      console.log("mongodbErr", error);
    }
  };

  return (
    <div style={{}}>
      <Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} name="basic" form={form}>
        <Form.Item
          style={{ marginBottom: "8px" }}
          label="Name"
          name="apinameName"
          validateStatus={
            apiName.length > 0 && apiName.length < 2
              ? "error"
              : resourceNameValidation.status === "duplicate" || (formSubmitted && apiName === "")
              ? "error"
              : resourceNameValidation.status === "available"
              ? "success"
              : ""
          }
          help={
            apiName.length > 0 && apiName.length < 2 ? (
              "Name must be at least 2 characters long!"
            ) : resourceNameValidation.status === "duplicate" ? (
              resourceNameValidation.message
            ) : resourceNameValidation.status === "available" ? (
              <span style={{ color: "#52c41a" }}>{resourceNameValidation.message}</span>
            ) : formSubmitted && apiName === "" ? (
              "Please input Name"
            ) : (
              ""
            )
          }
          rules={[
            { required: true, message: "Please input name" },
            { min: 2, message: "Name must be at least 2 characters lssong!" },
            {
              pattern: /^[a-zA-Z0-9\s_-]+$/,
              message: "Name can only contain letters, numbers, spaces, underscores, and hyphens",
            },
          ]}
        >
          <Input
            value={apiName}
            ref={resourceNameRef}
            onChange={(e) => {
              const newName = e.target.value;
              setApiName(newName);
              setApiNameError(false);

              const currentCursor = e.target.selectionStart;

              setCursorPosition(currentCursor);
              if (debounceTimer) {
                clearTimeout(debounceTimer);
              }

              if (newName.trim().length >= 2) {
                const newTimer = setTimeout(() => {
                  checkGroupNameDuplicate(newName);
                }, 800);

                setDebounceTimer(newTimer);
              }
            }}
            onKeyDown={(e) => {
              // Save cursor position on every keypress
              setCursorPosition(e.target.selectionStart);
            }}
            onClick={(e) => {
              // Save cursor position on click
              setCursorPosition(e.target.selectionStart);
            }}
            placeholder="e.g., Production MongoDB"
            disabled={props.isViewOnly}
            suffix={
              resourceNameValidation.status === "checking" ? (
                <Spin size="small" />
              ) : resourceNameValidation.status === "available" ? (
                <span style={{ color: "#52c41a", fontSize: "16px" }}>✓</span>
              ) : resourceNameValidation.status === "duplicate" ? (
                <span style={{ color: "#ff4d4f", fontSize: "16px" }}>⚠</span>
              ) : null
            }
          />
        </Form.Item>

        <Divider />

        <Form.Item
          style={{ marginBottom: "8px" }}
          label="Host"
          name="host"
          rules={[
            { required: true, message: "Please input Host " },
            {
              pattern:
                /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)*[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/,
              message: "Please enter a valid IP address or hostname",
            },
          ]}
          //   validateStatus={hostError ? "error" : ""}
        >
          <Input
            value={apiHost}
            onChange={(e) => {
              setApiHost(e.target.value);
              setHostError(false);
            }}
            placeholder="e.g., localhost, 127.0.0.1, mongodb.example.com"
            disabled={props.isViewOnly}
          />
        </Form.Item>

        <Form.Item label="Connection format" name="connectionType">
          {props.isViewOnly ? (
            <Radio.Group value={connectionType} disabled>
              <Radio.Button value={connectionType}>
                {connectionType === "dns" ? "DNS seed list connection" : "Standard connection"}
              </Radio.Button>
            </Radio.Group>
          ) : (
            <Radio.Group onChange={(e) => setConnectionType(e.target.value)}>
              <Radio.Button value="standard">Standard connection</Radio.Button>
              <Radio.Button value="dns">DNS seed list connection</Radio.Button>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item
          style={{ marginBottom: "8px" }}
          label="Port"
          name="port"
          rules={[
            { required: true, message: "Please input Port" },
            {
              pattern: /^[0-9]+$/,
              message: "Port must be a number",
            },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                const port = parseInt(value);
                if (port < 1 || port > 65535) {
                  return Promise.reject(new Error("Port must be between 1 and 65535"));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            value={portId}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, ""); // Only allow numbers
              setPortId(value);
              setPortError(false);
            }}
            placeholder="27017"
            maxLength={5}
            disabled={props.isViewOnly}
          />
        </Form.Item>

        <Form.Item
          style={{ marginBottom: "8px" }}
          label="Database Name"
          name="databaseName"
          rules={[
            { required: true, message: "Please input Database Name" },
            {
              pattern: /^[a-zA-Z0-9_-]+$/,
              message: "Database name can only contain letters, numbers, underscores, and hyphens",
            },
            {
              min: 1,
              max: 64,
              message: "Database name must be between 1 and 64 characters",
            },
          ]}
        >
          <Input
            value={databaseName}
            onChange={(e) => setDatabaseName(e.target.value)}
            placeholder="e.g., myapp_db"
            disabled={props.isViewOnly}
          />
        </Form.Item>

        <Form.Item
          style={{ marginBottom: "8px" }}
          label="Database Username"
          name="databaseUsername"
          rules={[
            { required: true, message: "Please input Database Username" },
            {
              pattern: /^[a-zA-Z0-9_.@-]+$/,
              message: "Username can only contain letters, numbers, underscores, dots, @ and hyphens",
            },
            {
              min: 3,
              max: 63,
              message: "Username must be at least 3 characters long",
            },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                if (value.trim() !== value) {
                  return Promise.reject(new Error("Username cannot start or end with spaces"));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            value={databaseUsername}
            onChange={(e) => setDatabaseUsername(e.target.value)}
            placeholder="e.g., admin, dbuser"
            disabled={props.isViewOnly}
          />
        </Form.Item>

        <Form.Item
          style={{ marginBottom: "8px" }}
          label="Database Password"
          name="databasePassword"
          rules={[
            { required: true, message: "Please input Database Password" },
            {
              min: 6,
              message: "Password must be at least 6 characters long",
            },
            {
              max: 128,
              message: "Password cannot exceed 128 characters",
            },
          ]}
        >
          <Input.Password
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            visibilityToggle={!props.isViewOnly && !props.isDisabled}
            value={databasePassword}
            onChange={(e) => setDatabasePassword(e.target.value)}
            placeholder="Enter password"
            disabled={props.isViewOnly}
          />
        </Form.Item>

        <Divider />

        {!props.isViewOnly && (
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Button
                htmlType="submit"
                onClick={testConnection}
                loading={apiTestStatus === "pending"}
                disabled={apiHost === "" || apiName === "" || portId === ""}
              >
                Test Connection
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                onClick={handleSaveConnection}
                loading={apiSaveStatus === "pending"}
                style={{ marginLeft: "8px" }}
              >
                {props.selectedResource ? "Update Resource" : "Create Resource"}
              </Button>
            </div>

            <div>
              {(() => {
                switch (apiTestStatus) {
                  case "success":
                    return <Alert message="Test Connection Success" type="success" showIcon />;
                  case "error":
                    return <Alert message="Test Connection Failed" type="error" showIcon />;
                  case "pending":
                    return (
                      <div>
                        <Spin />
                      </div>
                    );
                  default:
                    return null;
                }
              })()}

              {(() => {
                switch (apiSaveStatus) {
                  case "success":
                    return <Alert message="Saving database connection data Success" type="success" showIcon />;
                  case "error":
                    return <Alert message="Saving database connection data failed" type="error" showIcon />;
                  case "pending":
                    return (
                      <div>
                        <Spin />
                      </div>
                    );
                  default:
                    return null;
                }
              })()}
            </div>
          </div>
        )}
      </Form>
    </div>
  );
};

export default MongoDBForm;
